import * as React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import moment from 'moment';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { t } from 'utils/language';

import type { MessengerMessage } from 'types';

type StateProps = {
  lastSeenMessage: MessengerMessage | undefined | null
};

type OwnProps = {
  subcampaignId: number, // eslint-disable-line react/no-unused-prop-types,
  message: MessengerMessage
};

type Props = StateProps & OwnProps;

class MessageSeen extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { lastSeenMessage, message } = this.props;
    const lastSeenMessageDate = get(lastSeenMessage, 'createdAt', null);
    const messageDate = get(message, 'createdAt', null);

    if (!lastSeenMessageDate || !messageDate || moment(lastSeenMessageDate).isBefore(messageDate)) {
      return null;
    }

    return (
      <section className="message-seen">
        –
        <div className="message-seen__icon">
          <SVGDynamicIcon
            name="checkmark-custom-fg"
            width={10}
            height={8}
            customColor="primary"
          />
        </div>
        {t('messenger.seen_label')}
      </section>
    );
  }
}

const mapStateToProps = ({ messages }, props): StateProps => ({
  lastSeenMessage: messages.lastSeenMessageBySubcampaign[props.subcampaignId]
});

export default connect(mapStateToProps)(MessageSeen);
